var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activitiesFiltered.length)?_c('div',[_c('div',{staticClass:"caption d-flex grey--text text--darken-1 pb-",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-bottom":"1px"}},[(!_vm.hideText)?_c('div',{staticStyle:{"width":"90px"}},[_vm._v(_vm._s(_vm.title)+":")]):_vm._e(),_vm._l((_vm.activitiesFiltered),function(item,$i){return _c('div',{key:$i,staticClass:"px-1",style:({
          marginLeft: '1px',
          fontSize: '9px',
          borderRadius: '2px',
          fontWeight: 'bold',
          background: item.color,
          color: item.identifier === 'VX' ? 'black' : 'white'
        })},[_vm._v(" "+_vm._s(item.identifier === 'VX' ? _vm.parseVx(_vm.type === 'after' ? item.placeEnd : item.placeStart) : item.identifier)+" ")])})],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }